/**
 * Zapis do newslettera przy checkoutcie: tylko gdy user zaznaczył zgodę
 * i nie jest już zapisany. Best-effort — błąd nie może zablokować płatności.
 *
 * Wołać PO udanym saveReservation (konto już istnieje w bazie),
 * a PRZED forceGoToPayment — inaczej byEmail nie wyśle maila na nowy adres,
 * albo request zginie przy przekierowaniu do bramki.
 */
export const sendCheckoutNewsletterInvite = async ({
  sendInvite,
  facilityIds,
  email,
  allowMailing,
  alreadySubscribed,
}: {
  sendInvite: (ids: string, email: string) => Promise<void>;
  facilityIds: string;
  email?: string;
  allowMailing?: boolean;
  alreadySubscribed?: boolean;
}): Promise<void> => {
  if (!allowMailing || !email || alreadySubscribed) {
    return;
  }

  try {
    await sendInvite(facilityIds, email);
  } catch {
    // Ignorujemy — zapis do newslettera nie może zablokować zakupu.
  }
};
